import ApexCharts from 'apexcharts';

export default $wire => ({
    chart: null,

    init() {
        const priceHistory = $wire.priceHistory;
        const minPrice = $wire.minPrice;
        const maxPrice = $wire.maxPrice;

        // Destroy any existing chart instance
        if (this.chart) {
            this.chart.destroy();
        }

        const options = {
            series: [
                {
                    name: 'Price Range',
                    data: priceHistory.map(item => ({
                        x: item.date,
                        y: [item.min_price, item.max_price],
                    })),
                },
            ],
            chart: {
                height: 250,
                type: 'line',
                zoom: {
                    enabled: false,
                },
                toolbar: {
                    show: false,
                },
            },
            stroke: {
                curve: 'smooth',
                width: 2,
                lineCap: 'round',
            },
            markers: {
                size: 0, // Hide all default markers
                discrete: [
                    {
                        seriesIndex: 0,
                        dataPointIndex: 0,
                        fillColor: '#4F46E5',
                        strokeColor: '#fff',
                        size: 6,
                        shape: 'diamond',
                    },
                    {
                        seriesIndex: 0,
                        dataPointIndex: priceHistory.length - 1,
                        fillColor: '#4F46E5',
                        strokeColor: '#fff',
                        size: 6,
                        shape: 'diamond',
                    },
                ],
            },
            colors: ['#4F46E5'],
            grid: {
                borderColor: '#E2E8EE',
                xaxis: {
                    lines: {
                        show: false,
                    },
                },
                yaxis: {
                    lines: {
                        show: true,
                    },
                },
            },
            tooltip: {
                custom: function ({ series, seriesIndex, dataPointIndex }) {
                    const data = priceHistory[dataPointIndex];
                    return `
                        <div class="p-2">
                            <div class="font-bold">${data.date}</div>
                            <div>€${data.min_price} - €${data.max_price}</div>
                        </div>
                    `;
                },
            },
            xaxis: {
                type: 'category',
                tickPlacement: 'on',
                axisBorder: {
                    show: false,
                },
                labels: {
                    style: {
                        colors: '#7A8993',
                        fontSize: '12px',
                    },
                    offsetY: 5,
                    formatter: function (value, timestamp, opts) {
                        const index = priceHistory.findIndex(item => item.date === value);
                        return index === 0 || index === priceHistory.length - 1 ? value : '';
                    },
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                min: Math.floor(minPrice * 0.95),
                max: Math.ceil(maxPrice * 1.05),
                labels: {
                    style: {
                        colors: '#7A8993',
                        fontSize: '12px',
                    },
                    formatter: value => `€${Math.round(value)}`,
                },
            },
        };

        this.chart = new ApexCharts(document.querySelector('#listingPriceHistoryChart'), options);
        this.chart.render();
    },

    destroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    },
});
